(function(){
'use strict';
const $=(s,c=document)=>c.querySelector(s);
const $$=(s,c=document)=>[...c.querySelectorAll(s)];
const on=(el,ev,fn)=>el&&el.addEventListener(ev,fn);
const isPage=(...t)=>t.some(p=>document.body.classList.contains('template-'+p));

function initNavCleanup(){
  $$('.site-nav__item,.header__nav-item').forEach(item=>{
    const link=item.querySelector('a');
    if(!link)return;
    const txt=link.textContent.trim().toUpperCase();
    if(txt.includes('SUIVI COMMANDE')||txt==='ACCUEIL'||txt==='TOUS NOS PRODUITS')item.style.display='none';
  });
}

function initFAQ(){
  if(!isPage('product'))return;
  const desc=$('.product__description,.product-description,[class*="product-description"]');
  if(!desc)return;
  const faqs=[
    {q:'Matière & composition',a:'Retrouvez la composition exacte dans la description ci-dessus. Toutes nos pièces sont fabriquées avec des matériaux sélectionnés pour leur qualité et leur durabilité.'},
    {q:'Guide des tailles',a:'Nos pièces taillent normalement. En cas de doute entre deux tailles, optez pour la plus grande.'},
    {q:'Livraison & délais',a:'France : 3-5 jours ouvrés. International : 5-10 jours ouvrés. Expédition sous 24-48h après commande.'},
    {q:'Retours & échanges',a:'Retours acceptés sous 14 jours. Article non porté, étiquettes d\'origine attachées. Contact : malangebrand@gmail.com'},
    {q:'Paiement sécurisé',a:'Paiement 100% sécurisé via Shopify Payments. CB, PayPal, Apple Pay, Google Pay acceptés.'},
  ];
  const wrap=document.createElement('div');
  wrap.className='ma-faq';
  wrap.innerHTML='<div class="ma-faq-title">Informations</div>';
  faqs.forEach(f=>{
    const item=document.createElement('div');
    item.className='ma-faq-item';
    item.innerHTML=`<button class="ma-faq-q" aria-expanded="false"><span>${f.q}</span><span class="ma-faq-icon">+</span></button><div class="ma-faq-a">${f.a}</div>`;
    const btn=item.querySelector('.ma-faq-q'),ans=item.querySelector('.ma-faq-a');
    on(btn,'click',()=>{
      const open=btn.getAttribute('aria-expanded')==='true';
      $$('.ma-faq-q').forEach(b=>{b.setAttribute('aria-expanded','false');b.querySelector('.ma-faq-icon').textContent='+'});
      $$('.ma-faq-a').forEach(a=>{a.style.maxHeight='0';a.style.opacity='0';});
      if(!open){btn.setAttribute('aria-expanded','true');btn.querySelector('.ma-faq-icon').textContent='−';ans.style.maxHeight=ans.scrollHeight+'px';ans.style.opacity='1';}
    });
    wrap.appendChild(item);
  });
  desc.insertAdjacentElement('afterend',wrap);
}

function initBundleSuggestion(){
  if(!isPage('product'))return;
  const isHS=window.location.href.toLowerCase().includes('highschool')||document.title.toLowerCase().includes('highschool');
  if(!isHS)return;
  const pieces=[
    {name:'Varsity Jacket',price:'129,90 €',url:'/products/varsity-jacket-highschool',img:'https://cdn.shopify.com/s/files/1/0102/7460/3055/files/16-removebg-preview.png?v=1754519783'},
    {name:'Tee-Shirt',price:'22,90 €',url:'/collections/highschool',img:'https://cdn.shopify.com/s/files/1/0102/7460/3055/files/10-removebg-preview.png?v=1754519832'},
    {name:'Casquette',price:'17,90 €',url:'/collections/highschool',img:'https://cdn.shopify.com/s/files/1/0102/7460/3055/files/1_1.png?v=1735747553'},
  ];
  const cur=$('h1.title,.product__title')?.textContent?.trim().toLowerCase()||'';
  const others=pieces.filter(p=>!cur.includes(p.name.toLowerCase())).slice(0,3);
  if(others.length<2)return;
  const wrap=document.createElement('div');
  wrap.className='ma-bundle';
  wrap.innerHTML=`<div class="ma-bundle-header"><span class="ma-bundle-title">Compléter la tenue</span><span class="ma-bundle-sub">Collection Highschool</span></div><div class="ma-bundle-items">${others.map(p=>`<a href="${p.url}" class="ma-bundle-item"><div class="ma-bundle-img"><img src="${p.img}" alt="${p.name}" loading="lazy"></div><div class="ma-bundle-name">${p.name}</div><div class="ma-bundle-price">${p.price}</div></a>`).join('<div class="ma-bundle-plus">+</div>')}</div><a href="/collections/highschool" class="ma-bundle-cta">Voir le pack complet →</a>`;
  const form=$('[data-product-form],.product-form,form[action*="/cart/add"]');
  if(form)form.insertAdjacentElement('afterend',wrap);
}

function initDropTeaser(){
  if(!isPage('index'))return;
  if($('.ma-drop-teaser'))return;
  const dropDate=new Date('2026-07-12T18:00:00');
  if(new Date()>=dropDate)return;
  const teaser=document.createElement('div');
  teaser.className='ma-drop-teaser';
  teaser.innerHTML=`<div class="ma-dt-inner"><div class="ma-dt-left"><div class="ma-dt-eyebrow">Prochain drop</div><div class="ma-dt-title">12 Juillet<br>18:00</div><div class="ma-dt-timer"><div class="ma-dt-unit"><span class="ma-dt-num" id="dt-d">--</span><span class="ma-dt-lbl">Jours</span></div><div class="ma-dt-sep">:</div><div class="ma-dt-unit"><span class="ma-dt-num" id="dt-h">--</span><span class="ma-dt-lbl">Heures</span></div><div class="ma-dt-sep">:</div><div class="ma-dt-unit"><span class="ma-dt-num" id="dt-m">--</span><span class="ma-dt-lbl">Min</span></div><div class="ma-dt-sep">:</div><div class="ma-dt-unit"><span class="ma-dt-num" id="dt-s">--</span><span class="ma-dt-lbl">Sec</span></div></div></div><div class="ma-dt-right"><div class="ma-dt-form"><div class="ma-dt-form-title">Accès en avant-première</div><div class="ma-dt-form-sub">Sois le premier notifié le 12 juillet</div><form method="post" action="/contact#contact_form" class="ma-dt-input-wrap" accept-charset="UTF-8"><input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter,drop-juillet"><input type="email" name="contact[email]" class="ma-dt-input" placeholder="ton@email.com" required autocomplete="email"><button type="submit" class="ma-dt-btn">Rejoindre →</button></form><div class="ma-dt-privacy">-10% avec le code BIENVENUE10. Pas de spam.</div></div></div></div>`;
  const timerInterval=setInterval(()=>{
    const diff=dropDate-new Date();
    if(diff<=0){teaser.style.display='none';clearInterval(timerInterval);return;}
    const vals=[Math.floor(diff/86400000),Math.floor((diff%86400000)/3600000),Math.floor((diff%3600000)/60000),Math.floor((diff%60000)/1000)];
    ['d','h','m','s'].forEach((u,i)=>{const el=document.getElementById('dt-'+u);if(el)el.textContent=String(vals[i]).padStart(2,'0');});
  },1000);
  const hero=$('.shopify-section:nth-child(2),.shopify-section+.shopify-section');
  if(hero)hero.insertAdjacentElement('afterend',teaser);
  else{const main=$('#main,.main-content');if(main)main.insertAdjacentElement('afterbegin',teaser);}
}

function initSocialProofTicker(){
  if(!isPage('index'))return;
  if($('.ma-sp-ticker'))return;
  const ticker=document.createElement('div');
  ticker.className='ma-sp-ticker';
  ticker.innerHTML='<div class="ma-sp-inner">WORLDWIDE</div>';
  const header=$('.site-header,.header');
  if(header)header.insertAdjacentElement('afterend',ticker);
}

function initPackagingSection(){
  if(!isPage('index'))return;
  if($('.ma-packaging'))return;
  const sec=document.createElement('div');
  sec.className='ma-packaging';
  sec.innerHTML=`<div class="ma-pkg-content"><div class="ma-pkg-text"><div class="ma-pkg-label">L'expérience MalAnge</div><div class="ma-pkg-title">Du drop<br>à ta porte</div><div class="ma-pkg-body">Chaque commande MalAnge est emballée avec soin. Packaging soigné, édition numérotée, prêt à être porté.</div><div class="ma-pkg-features"><div class="ma-pkg-feat"><span>✦</span> Packaging premium</div><div class="ma-pkg-feat"><span>✦</span> Pièce numérotée</div><div class="ma-pkg-feat"><span>✦</span> Livraison rapide</div><div class="ma-pkg-feat"><span>✦</span> Édition limitée</div></div></div><div class="ma-pkg-visual"><div class="ma-pkg-img-wrap"><img src="https://malangeclothing.com/cdn/shop/files/55A0849-2_2a6d66c2-9e62-4f19-a02a-94078b672f59.jpg?v=1737331268" alt="MalAnge" loading="lazy"></div></div></div>`;
  const footer=$('footer,.site-footer');
  if(footer)footer.insertAdjacentElement('beforebegin',sec);
}

function initMobileZoom(){
  if(window.innerWidth>768)return;
  $$('.product-images img,.product__media img').forEach(img=>{
    const ov=document.createElement('div');ov.className='ma-zoom-overlay';
    ov.innerHTML=`<img src="${img.src}" alt="${img.alt}"><button class="ma-zoom-close">×</button>`;
    document.body.appendChild(ov);
    on(img,'click',()=>ov.classList.add('is-open'));
    on(ov.querySelector('.ma-zoom-close'),'click',()=>ov.classList.remove('is-open'));
    on(ov,'click',e=>{if(e.target===ov)ov.classList.remove('is-open');});
  });
}

function init(){
  initNavCleanup();
  initSocialProofTicker();
  initDropTeaser();
  initPackagingSection();
  initMobileZoom();
  if(isPage('product')){setTimeout(initFAQ,400);setTimeout(initBundleSuggestion,600);}
}

if(document.readyState!=='loading')init();
else document.addEventListener('DOMContentLoaded',init);
})();